import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=expansive%20stylized%20anime%20manga%20illustration%20landscape%20with%20floating%20comic%20book%20pages%2C%20ink%20splashes%2C%20and%20vibrant%20warm%20orange%20and%20amber%20coloring%2C%20dynamic%20composition%20with%20hero%20silhouettes%2C%20abstract%20artistic%20backdrop%2C%20high%20detail%20editorial%20concept%20art&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
          alt="漫画分类大全导航平台背景图"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:py-36">
        <span className="rounded-full bg-white/15 px-4 py-1.5 text-sm text-white backdrop-blur">
          <i className="ri-sparkling-2-fill mr-1 text-accent-300" />
          海量漫画 · 一站式分类导航
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-tight text-white sm:text-4xl md:text-6xl">
          漫画分类大全导航
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
          这里汇集<strong className="text-accent-300">漫画分类大全</strong>与<strong className="text-accent-300">漫画类型大全</strong>，
          按题材分类整理<strong className="text-accent-300">漫画推荐大全</strong>，并附漫画排行榜大全与漫画人气排行，
          帮你快速找到想看的漫画。
        </p>

        <div className="mt-10 flex w-full max-w-xl items-center gap-2 rounded-full bg-white p-1.5 shadow-sm">
          <i className="ri-search-line ml-3 text-xl text-foreground-400" />
          <input
            type="search"
            placeholder="搜索热血冒险、玄幻修仙、恋爱言情…"
            className="w-full bg-transparent py-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            aria-label="搜索漫画分类"
          />
          <Link
            to="/category"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始探索
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-white">
          <div className="text-center">
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">10+</p>
            <p className="mt-1 text-sm text-white/80">漫画类型大全</p>
          </div>
          <div className="h-10 w-px bg-white/30" />
          <div className="text-center">
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">900+</p>
            <p className="mt-1 text-sm text-white/80">收录人气漫画</p>
          </div>
          <div className="h-10 w-px bg-white/30" />
          <div className="text-center">
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">1200+</p>
            <p className="mt-1 text-sm text-white/80">推荐文章大全</p>
          </div>
          <div className="h-10 w-px bg-white/30" />
          <div className="text-center">
            <p className="font-heading text-2xl text-accent-300 md:text-3xl">每日更新</p>
            <p className="mt-1 text-sm text-white/80">人气排行数据</p>
          </div>
        </div>
      </div>
    </section>
  );
}